<template>
    <div class="temp3">
        temp3
    </div>
</template>
<script>
    export default{
        name:'temp3',
        data(){
            return {}
        }
    }
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/main-content/router-test/temp3.vue